import { render, staticRenderFns } from "./Temoignages.vue?vue&type=template&id=1b61625a&"
import script from "./Temoignages.vue?vue&type=script&lang=js&"
export * from "./Temoignages.vue?vue&type=script&lang=js&"
import style0 from "./Temoignages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports